import React from 'react';

/**
 * Mission target — stamped tin badge to match the robot pieces.
 * Filled plate + walnut outline + inner ring + glint. No <defs>/gradients:
 * url(#id) fragment refs break under CRA's <base href>.
 */
function TriangleIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="100%"
      height="100%"
      style={{ display: 'block' }}
    >
      <path
        d="M16 4.2L28.6 26.6H3.4L16 4.2z"
        fill={color}
        stroke="#2a1a0e"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M16 12.4L22.4 23.4H9.6L16 12.4z"
        fill="none"
        stroke="#fff"
        strokeOpacity="0.4"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <circle cx="16" cy="8.6" r="1.4" fill="#fff" opacity="0.5" />
    </svg>
  );
}

export default TriangleIcon;
